import { createGlobalState } from '@vueuse/core';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { PatentBasicService } from '@/domains/patent/services/patent-basic-service';
import { useFreeViewLimit } from '@/components/no-permission/composables/use-free-view-limit';
import { useI18n } from '@/composables/use-i18n';
import type { PatentBasicEntity } from '@/domains/patent/types';

const OVER_FREE_VIEW_LIMIT_CODE = 'commonStatusCode.11160405';

export const usePatentBasic = createGlobalState(() => {
    const {
        setIsOverFreeView,
    } = useFreeViewLimit();

    const {
        t,
    } = useI18n();

    /**
     * 访问限制提示
     */
    const patentBasicService = injectService<PatentBasicService>(PatentBasicService);

    patentBasicService.onOverLimit(() => {
        setIsOverFreeView(true, t(OVER_FREE_VIEW_LIMIT_CODE));
    });

    /**
     * 异步获取专利基本信息
     */
    const getPatentBase = async (patentId: string)  => {
        return await patentBasicService.getPatentBase(patentId);
    };

    /**
     * 获取专利摘要默认值
     */
    const getPatentDefaultOfAbst = (patent: PatentBasicEntity) => {
        return patentBasicService.getPatentDefaultOfAbst(patent);
    };

    /**
     * 获取专利标题默认值
     */
    const getPatentDefaultOfTitle = (patent: PatentBasicEntity) => {
        return patentBasicService.getPatentDefaultOfTitle(patent);
    };

    return {
        getPatentBase,
        getPatentDefaultOfAbst,
        getPatentDefaultOfTitle,
    };
});
